module.exports = __webpack_public_path__ + "c43e42b6d8390dbf532249afb86f487e.svg";